import { Component, OnDestroy, OnInit, computed, input, output } from '@angular/core';
import { ICreateManageUserState, IManageuser, initialCreateManageUserState } from 'src/app/store/createManageUser/state';
import { Lux } from '@roosevelt/common-ui-lib/core';

@Component({
    selector: 'bmt-manage-auth',
    templateUrl: './manage-auth.component.html',
    styleUrls: ['./manage-auth.component.scss'],
    standalone: false
})
export class ManageAuthComponent implements OnInit, OnDestroy {
  luxId = 'BMT-manage-auth' + this.constructor.name;

  readonly userInfo = input.required<IManageuser>();
  readonly cancelEdit = output<boolean>();
  private readonly singleClientOrSubGroupAdmins = ['BMT-GROUP-ADMIN', 'BMT-SUBGROUP-ADMIN', 'BMT-GROUP-DELEGATE', 'BMT-SUBGROUP-DELEGATE'];
  readonly canManageAtClientLevel = computed(() => !this.singleClientOrSubGroupAdmins.includes(this.userInfo().adminRole));
  readonly initailAdminUserAuthResponse = initialCreateManageUserState.adminAndUserAuths;

  constructor(private readonly lux: Lux<{ createManageUserState: ICreateManageUserState }>) {
  }

  ngOnDestroy(): void {
    this.lux.destroy(this.luxId);
  }

  clearTheAdminUserState() {
    this.lux.set(state => state.createManageUserState.manageUserAuths, { authResponse: '', errors: '' });
    this.lux.set(state => state.createManageUserState.adminAndUserAuths, {
      authResponse: this.initailAdminUserAuthResponse.authResponse,
      errors: ''
    });
  }

  ngOnInit(): void {
    this.clearTheAdminUserState();
  }


}
